import {
  Droplets,
  Shield,
  Sun,
  Sparkles,
  CalendarCheck,
  Snowflake,
  X,
  Check,
  ArrowRight,
  ArrowDown,
} from "lucide-react";
import { Button } from "./ui/button";

/* -------- Inline SVG: paint cross-section (without ceramic) -------- */
function PaintStackBare() {
  return (
    <svg viewBox="0 0 200 140" className="w-full h-auto" aria-hidden="true">
      <defs>
        <linearGradient id="bare-clear" x1="0" x2="0" y1="0" y2="1">
          <stop offset="0" stopColor="#2b2b2b" />
          <stop offset="1" stopColor="#171717" />
        </linearGradient>
      </defs>
      {/* Layers */}
      <rect x="10" y="100" width="180" height="20" fill="#1a1a1a" />
      <rect x="10" y="80" width="180" height="20" fill="#3b3b3b" />
      <rect x="10" y="60" width="180" height="20" fill="#9a8cb6" />
      <rect x="10" y="40" width="180" height="20" fill="url(#bare-clear)" />
      {/* Damage marks on clear coat */}
      <path d="M20 50 L40 45 M60 52 L80 47 M100 50 L120 46 M140 51 L165 47" stroke="#5a5a5a" strokeWidth="1.2" strokeLinecap="round" />
      {/* Labels */}
      <text x="195" y="115" fontSize="6" fill="#888" textAnchor="end" fontFamily="Inter">Steel</text>
      <text x="195" y="95" fontSize="6" fill="#888" textAnchor="end" fontFamily="Inter">Primer</text>
      <text x="195" y="75" fontSize="6" fill="#bba4dc" textAnchor="end" fontFamily="Inter">Base coat</text>
      <text x="195" y="55" fontSize="6" fill="#888" textAnchor="end" fontFamily="Inter">Clear coat (exposed)</text>
      {/* Threats */}
      <text x="100" y="20" fontSize="9" fill="#ff5c5c" textAnchor="middle" fontFamily="Bebas Neue" letterSpacing="1.2">UV · SALT · BUGS · SWIRLS · BIRD DROPPINGS</text>
      <path d="M40 25 L40 38 M70 25 L70 38 M100 25 L100 38 M130 25 L130 38 M160 25 L160 38" stroke="#ff5c5c" strokeWidth="1.5" strokeDasharray="2 2" />
      <polygon points="40,38 38,34 42,34" fill="#ff5c5c" />
      <polygon points="70,38 68,34 72,34" fill="#ff5c5c" />
      <polygon points="100,38 98,34 102,34" fill="#ff5c5c" />
      <polygon points="130,38 128,34 132,34" fill="#ff5c5c" />
      <polygon points="160,38 158,34 162,34" fill="#ff5c5c" />
    </svg>
  );
}

/* -------- Inline SVG: paint cross-section WITH 2-layer Gtechniq -------- */
function PaintStackProtected() {
  return (
    <svg viewBox="0 0 200 140" className="w-full h-auto" aria-hidden="true">
      <defs>
        <linearGradient id="prot-clear" x1="0" x2="0" y1="0" y2="1">
          <stop offset="0" stopColor="#2b2b2b" />
          <stop offset="1" stopColor="#171717" />
        </linearGradient>
        <linearGradient id="csl-grad" x1="0" x2="0" y1="0" y2="1">
          <stop offset="0" stopColor="#FF6B6B" />
          <stop offset="1" stopColor="#c63030" />
        </linearGradient>
        <linearGradient id="exo-grad" x1="0" x2="0" y1="0" y2="1">
          <stop offset="0" stopColor="#A8E000" />
          <stop offset="1" stopColor="#7eb800" />
        </linearGradient>
      </defs>
      {/* Layers */}
      <rect x="10" y="115" width="180" height="15" fill="#1a1a1a" />
      <rect x="10" y="100" width="180" height="15" fill="#3b3b3b" />
      <rect x="10" y="85" width="180" height="15" fill="#9a8cb6" />
      <rect x="10" y="70" width="180" height="15" fill="url(#prot-clear)" />
      <rect x="10" y="60" width="180" height="10" fill="url(#csl-grad)" />
      <rect x="10" y="50" width="180" height="10" fill="url(#exo-grad)" />
      {/* Glow on top */}
      <rect x="10" y="46" width="180" height="4" fill="#A8E000" opacity="0.4" />
      {/* Water beads on EXO */}
      <circle cx="35" cy="44" r="4" fill="#62b3ff" opacity="0.85" />
      <circle cx="36" cy="42" r="1.2" fill="#cce6ff" />
      <circle cx="75" cy="44" r="3.5" fill="#62b3ff" opacity="0.85" />
      <circle cx="76" cy="42.5" r="1" fill="#cce6ff" />
      <circle cx="115" cy="44" r="4.2" fill="#62b3ff" opacity="0.85" />
      <circle cx="116" cy="42" r="1.3" fill="#cce6ff" />
      <circle cx="155" cy="44" r="3.5" fill="#62b3ff" opacity="0.85" />
      <circle cx="156" cy="42.5" r="1" fill="#cce6ff" />
      {/* Threat arrows bouncing off */}
      <text x="100" y="20" fontSize="9" fill="#A8E000" textAnchor="middle" fontFamily="Bebas Neue" letterSpacing="1.2">SHIELDED · 5 YEARS · GTECHNIQ</text>
      <path d="M40 25 L40 38 M70 25 L70 38 M100 25 L100 38 M130 25 L130 38 M160 25 L160 38" stroke="#A8E000" strokeWidth="1.5" strokeDasharray="2 2" opacity="0.7" />
      {/* Reverse arrows = bounced */}
      <polygon points="40,25 38,29 42,29" fill="#A8E000" />
      <polygon points="70,25 68,29 72,29" fill="#A8E000" />
      <polygon points="100,25 98,29 102,29" fill="#A8E000" />
      <polygon points="130,25 128,29 132,29" fill="#A8E000" />
      <polygon points="160,25 158,29 162,29" fill="#A8E000" />
      {/* Labels */}
      <text x="195" y="127" fontSize="5" fill="#888" textAnchor="end" fontFamily="Inter">Steel</text>
      <text x="195" y="112" fontSize="5" fill="#888" textAnchor="end" fontFamily="Inter">Primer</text>
      <text x="195" y="97" fontSize="5" fill="#bba4dc" textAnchor="end" fontFamily="Inter">Base coat</text>
      <text x="195" y="82" fontSize="5" fill="#888" textAnchor="end" fontFamily="Inter">Clear coat</text>
      <text x="195" y="68" fontSize="5" fill="#FF6B6B" textAnchor="end" fontFamily="Bebas Neue" letterSpacing="1">CSL ← Hard base</text>
      <text x="195" y="58" fontSize="5" fill="#A8E000" textAnchor="end" fontFamily="Bebas Neue" letterSpacing="1">EXO v5 ← Top coat</text>
    </svg>
  );
}

/* -------- Water bead diagram (contact angle) -------- */
function ContactAngleDiagram({ protected: isProtected }) {
  return (
    <svg viewBox="0 0 160 80" className="w-full h-auto" aria-hidden="true">
      <line x1="10" y1="60" x2="150" y2="60" stroke={isProtected ? "#A8E000" : "#666"} strokeWidth="2" />
      {isProtected ? (
        <>
          {/* High contact angle = bead */}
          <circle cx="80" cy="48" r="14" fill="#62b3ff" opacity="0.85" />
          <circle cx="78" cy="45" r="3" fill="#cce6ff" />
          <text x="80" y="76" fontSize="7" fill="#A8E000" textAnchor="middle" fontFamily="Bebas Neue" letterSpacing="1.2">110° beading</text>
        </>
      ) : (
        <>
          {/* Low contact angle = wet flat */}
          <ellipse cx="80" cy="58" rx="34" ry="6" fill="#62b3ff" opacity="0.7" />
          <text x="80" y="76" fontSize="7" fill="#888" textAnchor="middle" fontFamily="Bebas Neue" letterSpacing="1.2">35° wets paint</text>
        </>
      )}
    </svg>
  );
}

/* -------- The 6 main benefits -------- */
const BENEFITS = [
  { icon: Droplets, title: "Water Beads Off", desc: "Hydrophobic top coat means water rolls off in tight beads. Rain becomes self-cleaning and your car wash takes 10 minutes." },
  { icon: Shield, title: "Scratch Resistant", desc: "Hard nano-ceramic shield resists wash swirls and light scratches that ruin clear coat." },
  { icon: Sun, title: "No Faded Paint", desc: "UV rays, road film and oxidation can't reach your clear coat. your paint stays as deep and glossy as day one for years." },
  { icon: Sparkles, title: "Glass-Deep Gloss", desc: "Adds a wet-look depth your factory paint cannot produce on its own." },
  { icon: Snowflake, title: "Winter Protection", desc: "Road salt, slush, ice and snow slide off the EXO v5 top coat. No more salt etching, no more brake-dust streaks all winter." },
  { icon: CalendarCheck, title: "5-Year Warranty", desc: "Hand-applied, written warranty, free annual inspection. Peace of mind for years." },
];

/* -------- Why 2-layer beats single-layer table -------- */
const COMPARE = [
  { trait: "Surface hardness", single: "good", two: "max. Crystal Serum Light bonds at 9H" },
  { trait: "Hydrophobic gloss", single: "okay", two: "max. EXO v5 designed purely for slickness" },
  { trait: "Chemical resistance", single: "limited", two: "pH 2 → pH 12, -40°C → +250°C" },
  { trait: "Self-cleaning", single: "weak", two: "EXO is omniphobic (repels water + oil)" },
  { trait: "Real-world durability", single: "1-2 years", two: "5 years with maintenance washes" },
];

export default function CeramicEducation() {
  return (
    <section
      id="how-it-works"
      data-testid="ceramic-education-section"
      className="relative py-28 md:py-32 overflow-hidden bg-gradient-to-b from-[#0c0119] via-[#120127] to-[#0c0119] border-y border-white/5"
    >
      {/* Decorative orbs */}
      <div className="absolute top-1/3 -left-32 w-[500px] h-[500px] rounded-full bg-jester-purple/10 blur-[140px]" />
      <div className="absolute bottom-1/4 -right-32 w-[500px] h-[500px] rounded-full bg-acid/8 blur-[140px]" />

      <div className="relative max-w-7xl mx-auto px-6 md:px-10">
        {/* Section header */}
        <div className="max-w-3xl">
          <div className="text-xs uppercase tracking-[0.3em] text-acid mb-5 font-label">
           How It Works · 60-Second Read
          </div>
          <h2 className="font-display text-5xl md:text-6xl leading-[0.95]">
            What is <span className="text-jester">ceramic coating</span>,
            actually?
          </h2>
          <p className="mt-5 text-lg text-white/70 leading-relaxed">
            Skip the jargon. In one minute you'll understand exactly what we
            apply, why the <strong className="text-white">Gtechniq 2-layer
            system</strong> beats every other ceramic on the market, and what
            you walk away with after $550.
          </p>
        </div>

        {/* === BLOCK 1. With vs Without === */}
        <div className="mt-16 grid lg:grid-cols-2 gap-5">
          {/* Without */}
          <div
            data-testid="edu-without"
            className="rounded-2xl border border-white/10 bg-jester-card p-7"
          >
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 rounded-full bg-red-500/15 border border-red-500/40 flex items-center justify-center">
                <X className="w-4 h-4 text-red-400" />
              </div>
              <span className="text-[10px] uppercase tracking-[0.3em] text-red-400 font-label">Without ceramic</span>
            </div>
            <h3 className="font-display text-2xl mb-2">Naked clear coat.</h3>
            <p className="text-sm text-white/60 mb-5">
              Your factory clear coat sits exposed. UV oxidizes it. Salt etches it.
              Wash swirls accumulate. Within 2-3 years, gloss fades and paint dulls.
            </p>
            <PaintStackBare />
            <div className="mt-4">
              <ContactAngleDiagram protected={false} />
            </div>
          </div>

          {/* With Gtechniq */}
          <div
            data-testid="edu-with-gtechniq"
            className="relative rounded-2xl border border-acid/40 bg-gradient-to-br from-jester-purple/15 to-[#120127] p-7"
          >
            <div className="absolute -inset-px rounded-2xl shimmer pointer-events-none opacity-40" />
            <div className="relative">
              <div className="flex items-center gap-2 mb-4">
                <div className="w-8 h-8 rounded-full bg-acid/15 border border-acid/40 flex items-center justify-center">
                  <Check className="w-4 h-4 text-acid" />
                </div>
                <span className="text-[10px] uppercase tracking-[0.3em] text-acid font-label">
                  With Gtechniq 2-layer
                </span>
              </div>
              <h3 className="font-display text-2xl mb-2">
                Locked behind <span className="text-acid">two ceramic shields.</span>
              </h3>
              <p className="text-sm text-white/65 mb-5">
                Crystal Serum Light bonds chemically as a hard nano-ceramic base.
                EXO v5 layers on top for water-flicking gloss. Together they form
                a 5-year glass-deep barrier.
              </p>
              <PaintStackProtected />
              <div className="mt-4">
                <ContactAngleDiagram protected={true} />
              </div>
            </div>
          </div>
        </div>

        {/* === BLOCK 2. How the Gtechniq 2-layer system is built === */}
        <div className="mt-24">
          <div className="text-center max-w-3xl mx-auto mb-14">
            <div className="text-xs uppercase tracking-[0.3em] text-acid mb-5 font-label">
             The Gtechniq 2-Layer System
            </div>
            <h2 className="font-display text-4xl md:text-5xl leading-[0.95]">
              Two layers.{" "}
              <span className="text-jester">One job each.</span>{" "}
              <span className="text-acid">Zero compromises.</span>
            </h2>
            <p className="mt-5 text-white/65 leading-relaxed">
              Most ceramic coatings try to do everything in one bottle.
              hardness <em>and</em> hydrophobics. and end up okay at both.
              Gtechniq splits the job into two specialised products and stacks
              them. That's why it outperforms every single-layer ceramic on the
              market.
            </p>
          </div>

          {/* 3-step stacked diagram */}
          <div className="grid lg:grid-cols-3 gap-5">
            {/* Step 1. Prepped paint */}
            <div
              data-testid="edu-step-1"
              className="layer-rise-1 relative rounded-2xl border border-white/10 bg-jester-card p-7 hover-lift"
            >
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 rounded-xl bg-jester-purple/20 border border-white/10 flex items-center justify-center font-stencil text-acid text-sm">01</div>
                <div className="text-[10px] uppercase tracking-[0.3em] text-white/45 font-label">Step 1 · Prep</div>
              </div>
              <h3 className="font-display text-xl mb-3">Decon &amp; correction</h3>
              {/* SVG: bare prepped panel */}
              <svg viewBox="0 0 200 80" className="w-full h-auto mb-4" aria-hidden="true">
                <rect x="10" y="40" width="180" height="30" fill="#2b2b2b" />
                <rect x="10" y="36" width="180" height="4" fill="#444" />
                <text x="100" y="20" fontSize="9" fill="#aaa" textAnchor="middle" fontFamily="Bebas Neue" letterSpacing="1.2">CLEAN · SWIRL-FREE PAINT</text>
              </svg>
              <p className="text-sm text-white/65 leading-relaxed">
                Full decontamination wash, iron decon, clay treatment, then
                1-stage paint correction to remove swirl marks. Coatings lock
                in whatever's underneath. so this step is non-negotiable.
              </p>
            </div>

            {/* Step 2. CSL */}
            <div
              data-testid="edu-step-2"
              className="layer-rise-2 relative rounded-2xl border border-red-500/40 bg-gradient-to-br from-red-900/20 to-[#120127] p-7 hover-lift"
            >
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 rounded-xl bg-red-500/15 border border-red-500/30 flex items-center justify-center font-stencil text-red-300 text-sm">02</div>
                <div className="text-[10px] uppercase tracking-[0.3em] text-red-300 font-label">Step 2 · Hard Base</div>
              </div>
              <h3 className="font-display text-xl mb-1">
                <span className="text-red-300">Crystal Serum Light</span>
              </h3>
              <div className="text-[10px] uppercase tracking-[0.2em] text-red-200/70 font-label mb-3">
                Gtechniq · CSL
              </div>
              {/* SVG: CSL applied */}
              <svg viewBox="0 0 200 80" className="w-full h-auto mb-4" aria-hidden="true">
                <rect x="10" y="40" width="180" height="30" fill="#2b2b2b" />
                <rect x="10" y="34" width="180" height="6" fill="#444" />
                <rect x="10" y="28" width="180" height="6" fill="url(#csl-grad-2)" />
                <defs>
                  <linearGradient id="csl-grad-2" x1="0" x2="0" y1="0" y2="1">
                    <stop offset="0" stopColor="#FF6B6B" />
                    <stop offset="1" stopColor="#c63030" />
                  </linearGradient>
                </defs>
                <text x="100" y="20" fontSize="9" fill="#FF6B6B" textAnchor="middle" fontFamily="Bebas Neue" letterSpacing="1.2">9H NANO-CERAMIC BASE</text>
              </svg>
              <p className="text-sm text-white/65 leading-relaxed">
                A composite ceramic that bonds chemically to your clear coat.
                Maximum hardness, swirl-resistance and chemical resistance from
                pH 2 to pH 12. The shield underneath everything.
              </p>
            </div>

            {/* Step 3. EXO v5 */}
            <div
              data-testid="edu-step-3"
              className="layer-rise-3 relative rounded-2xl border border-acid/40 bg-gradient-to-br from-acid/10 to-[#120127] p-7 hover-lift"
            >
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 rounded-xl bg-acid/15 border border-acid/30 flex items-center justify-center font-stencil text-acid text-sm">03</div>
                <div className="text-[10px] uppercase tracking-[0.3em] text-acid font-label">Step 3 · Top Coat</div>
              </div>
              <h3 className="font-display text-xl mb-1">
                <span className="text-acid">EXO v5</span>
              </h3>
              <div className="text-[10px] uppercase tracking-[0.2em] text-acid/70 font-label mb-3">
                Gtechniq · Hydrophobic Top Coat
              </div>
              {/* SVG: EXO on top */}
              <svg viewBox="0 0 200 80" className="w-full h-auto mb-4" aria-hidden="true">
                <rect x="10" y="40" width="180" height="30" fill="#2b2b2b" />
                <rect x="10" y="34" width="180" height="6" fill="#444" />
                <rect x="10" y="28" width="180" height="6" fill="#c63030" />
                <rect x="10" y="22" width="180" height="6" fill="#A8E000" />
                {/* beads */}
                <circle cx="40" cy="16" r="3.5" fill="#62b3ff" opacity="0.85" />
                <circle cx="80" cy="14" r="3" fill="#62b3ff" opacity="0.85" />
                <circle cx="120" cy="16" r="3.8" fill="#62b3ff" opacity="0.85" />
                <circle cx="160" cy="15" r="3.2" fill="#62b3ff" opacity="0.85" />
                <text x="100" y="9" fontSize="8" fill="#A8E000" textAnchor="middle" fontFamily="Bebas Neue" letterSpacing="1.2">OMNIPHOBIC + HIGH GLOSS</text>
              </svg>
              <p className="text-sm text-white/65 leading-relaxed">
                The slickest, glossiest, most water-flicking layer Gtechniq
                makes. Repels both water <em>and</em> oil ("omniphobic"), gives
                paint a warmer "wet-look" than sterile single-layer ceramics.
              </p>
            </div>
          </div>

          {/* Combine arrow */}
          <div className="flex justify-center my-10">
            <ArrowDown className="w-7 h-7 text-acid animate-bounce" />
          </div>

          {/* Final result block */}
          <div
            data-testid="edu-result"
            className="rounded-2xl border border-acid/40 bg-gradient-to-br from-jester-purple/10 to-[#120127] p-8 md:p-10 text-center"
          >
            <div className="text-[10px] uppercase tracking-[0.3em] text-acid mb-3 font-label">
              The Result · Your $550 Package
            </div>
            <h3 className="font-display text-3xl md:text-4xl">
              <span className="text-acid">Glass-deep gloss.</span>{" "}
              <span className="text-jester">Five-year shield.</span>{" "}
              Effortless washes.
            </h3>
            <p className="mt-4 text-white/65 max-w-2xl mx-auto leading-relaxed">
              Together CSL + EXO v5 form a single hardened ceramic system.
              optically clear, ultra-durable, slick to the touch. The same
              system Gtechniq engineered for elite detailers worldwide. Now
              hand-applied in our Mississauga bay.
            </p>
          </div>
        </div>

        {/* === BLOCK 3. Why our 2-layer system is the best === */}
        <div className="mt-24">
          <div className="text-center max-w-3xl mx-auto mb-12">
            <div className="text-xs uppercase tracking-[0.3em] text-acid mb-5 font-label">
             2-Layer vs Single-Layer
            </div>
            <h2 className="font-display text-4xl md:text-5xl leading-[0.95]">
              Why the <span className="text-jester">Gtechniq 2-layer</span> beats every single-layer ceramic.
            </h2>
          </div>

          <div
            data-testid="edu-compare-table"
            className="rounded-2xl border border-white/10 bg-jester-card overflow-hidden"
          >
            <div className="grid grid-cols-3 gap-px bg-white/5">
              <div className="bg-[#0c0119] p-4 md:p-5 text-[10px] uppercase tracking-[0.2em] text-white/45 font-label">Trait</div>
              <div className="bg-[#0c0119] p-4 md:p-5 text-[10px] uppercase tracking-[0.2em] text-white/45 font-label">
                Single-layer ceramic
              </div>
              <div className="bg-[#0c0119] p-4 md:p-5 text-[10px] uppercase tracking-[0.2em] text-acid font-label">
                CSL + EXO v5 (us)
              </div>
              {COMPARE.map((row, i) => (
                <div key={i} className="contents">
                  <div className="bg-jester-card p-4 md:p-5 text-sm font-semibold text-white">
                    {row.trait}
                  </div>
                  <div className="bg-jester-card p-4 md:p-5 text-sm text-white/55 flex items-center gap-2">
                    <X className="w-3.5 h-3.5 text-red-400 flex-shrink-0" />
                    {row.single}
                  </div>
                  <div className="bg-jester-purple/10 p-4 md:p-5 text-sm text-white flex items-center gap-2">
                    <Check className="w-3.5 h-3.5 text-acid flex-shrink-0" />
                    {row.two}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* === BLOCK 4. 6 benefits grid === */}
        <div className="mt-24">
          <div className="text-center max-w-3xl mx-auto mb-12">
            <div className="text-xs uppercase tracking-[0.3em] text-acid mb-5 font-label">
             What You Walk Away With
            </div>
            <h2 className="font-display text-4xl md:text-5xl leading-[0.95]">
              Six things that change the day you drive away.
            </h2>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
            {BENEFITS.map((b, i) => {
              const Icon = b.icon;
              return (
                <div
                  key={i}
                  data-testid={`edu-benefit-${i}`}
                  className="rounded-2xl border border-white/10 bg-jester-card p-6 hover:border-acid/40 transition-colors group"
                >
                  <div className="w-11 h-11 rounded-xl bg-acid/10 border border-acid/30 flex items-center justify-center mb-4 group-hover:bg-acid/20 transition-colors">
                    <Icon className="w-5 h-5 text-acid" />
                  </div>
                  <h3 className="font-display text-xl mb-2">{b.title}</h3>
                  <p className="text-sm text-white/65 leading-relaxed">{b.desc}</p>
                </div>
              );
            })}
          </div>
        </div>

        {/* === BLOCK 5. Final CTA === */}
        <div
          data-testid="edu-final-cta"
          className="mt-24 relative rounded-3xl border border-acid/40 bg-gradient-to-br from-jester-purple/20 via-[#1a0938] to-[#120127] p-8 md:p-14 text-center overflow-hidden"
        >
          <div className="absolute -top-20 -right-20 w-80 h-80 rounded-full bg-acid/10 blur-[100px]" />
          <div className="absolute -bottom-20 -left-20 w-80 h-80 rounded-full bg-jester-purple/15 blur-[100px]" />
          <div className="relative">
            <div className="text-[10px] uppercase tracking-[0.3em] text-acid mb-4 font-label">
             Limited Spots · Content-Based Offer
            </div>
            <h2 className="font-display text-4xl md:text-6xl leading-[0.95]">
              Lock in the full <br className="hidden md:block" />
              Gtechniq system for{" "}
              <span className="text-acid">$550.</span>
            </h2>
            <p className="mt-5 text-white/70 max-w-xl mx-auto leading-relaxed">
              Crystal Serum Light + EXO v5 + 1-stage paint correction + free
              window coating + 5-year warranty. Regularly $1,500.
            </p>
            <div className="mt-9 flex flex-wrap justify-center gap-4">
              <Button
                asChild
                size="lg"
                data-testid="edu-cta-primary"
                className="bg-acid hover:bg-[#bff020] text-[#120127] font-label tracking-[0.2em] rounded-full px-9 h-13 shadow-[0_0_40px_rgba(168,224,0,0.45)]"
              >
                <a href="#contact" className="flex items-center gap-2">
                  Book Now <ArrowRight className="w-4 h-4" />
                </a>
              </Button>
              <Button
                asChild
                variant="outline"
                size="lg"
                data-testid="edu-cta-secondary"
                className="rounded-full border-jester bg-jester-purple/15 hover:bg-jester-purple/30 text-white h-13 px-8 font-label tracking-[0.2em]"
              >
                <a href="#pricing">See All Packages</a>
              </Button>
            </div>
            <p className="mt-7 text-xs uppercase tracking-[0.3em] text-white/40 font-label">
              Or call <a href="tel:6476467223" className="text-acid hover:text-white">(647) 646-7223</a> · written quote in 24 hours
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
